var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"app-container--width-max"},[_c('h1',[_vm._v("Application complete: "+_vm._s(this.getApplicationReference))])])
}
var staticRenderFns = []

export { render, staticRenderFns }